const apiDateFormat = "yyyy-MM-dd";

export default apiDateFormat;
